




// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import { AiOutlinePlus, AiOutlineHistory } from "react-icons/ai";
// import { MdVerifiedUser } from "react-icons/md";
// import { RiWallet3Fill, RiBankCard2Fill } from "react-icons/ri";
// import { BsArrowRightShort, BsShieldCheck } from "react-icons/bs";
// import { LanguageContext } from "../Components/LanguageContext";
// import Rightcontainer from "../Components/Rightcontainer";
// // import "./Mywallet.css";

// const Mywallet = ({ user }) => {
//   const { language } = useContext(LanguageContext);

//   const translations = {
//     hi: {
//       wallet: "वॉलेट बैलेंस",
//       secure: "MKADDA सुरक्षित कैश",
//       available: "कुल उपलब्ध शेष",
//       deposit: "डिपॉजिट",
//       winnings: "विनिंग्स",
//       history: "ट्रांजैक्शन हिस्ट्री",
//       add: "कैश जोड़ें",
//       withdraw: "पैसे निकालें",
//       verified: "वेरिफाइड",
//       encrypted: "256-बिट सुरक्षित एन्क्रिप्टेड गेटवे",
//     },
//     en: {
//       wallet: "Wallet Balance",
//       secure: "MKADDA Secure Cash",
//       available: "AVAILABLE BALANCE",
//       deposit: "Deposit",
//       winnings: "Winnings",
//       history: "Transaction History",
//       add: "ADD CASH",
//       withdraw: "WITHDRAW MONEY",
//       verified: "Verified",
//       encrypted: "256-BIT SECURE ENCRYPTED GATEWAY",
//     },
//   };

//   const t = translations[language] || translations.en;

//   // Safe formatting helpers
//   const totalBalance = Number(user?.Wallet_balance || 0);
//   const winningsBalance = Number(user?.withdrawAmount || 0);
//   const depositBalance = Math.max(0, totalBalance - winningsBalance);

//   return (
//     <div className="sa-wallet-wrapper leftContainer mt-5 pt-5">
//       {/* Background ambient lighting blur effects */}
//       <div className="sa-ambient-glow sa-glow-1"></div>
//       <div className="sa-ambient-glow sa-glow-2"></div>

//       <div className="sa-wallet-container">
//         {/* Header Banner */}
//         <div className="sa-header">
//           <div className="sa-header-text">
//             <h1>{t.wallet}</h1>
//             <p>{t.secure}</p>
//           </div>
//           <div className="sa-wallet-icon-box">
//             <RiWallet3Fill />
//           </div>
//         </div>

//         {/* Main Available Balance Hero Card */}
//         <div className="sa-main-balance-card">
//           <div className="sa-card-glow-bg"></div>
//           <div className="sa-balance-top">
//             <span className="sa-balance-label">{t.available}</span>
//             <div className="sa-verified-badge">
//               <MdVerifiedUser className="sa-badge-icon" />
//               <span>{t.verified}</span>
//             </div>
//           </div>
//           <div className="sa-balance-value">
//             <span className="currency-symbol">₹</span>
//             <span className="amount-number">{totalBalance.toFixed(2)}</span>
//           </div>
//         </div>

//         {/* Breakdown Stats Grid */}
//         <div className="sa-stats-grid">
//           <div className="sa-stat-box deposit-box">
//             <div className="sa-stat-header">
//               <span className="sa-stat-dot green"></span>
//               <span className="sa-stat-label">{t.deposit}</span>
//             </div>
//             <span className="sa-stat-value">₹{depositBalance.toFixed(2)}</span>
//           </div>

//           <div className="sa-stat-box winnings-box">
//             <div className="sa-stat-header">
//               <span className="sa-stat-dot gold"></span>
//               <span className="sa-stat-label">{t.winnings}</span>
//             </div>
//             <span className="sa-stat-value">₹{winningsBalance.toFixed(2)}</span>
//           </div>
//         </div>

//         {/* Action Buttons */}
//         <div className="sa-actions-grid">
//           <Link to="/addcase" className="sa-btn sa-btn-add">
//             <div className="sa-btn-icon-wrapper">
//               <AiOutlinePlus />
//             </div>
//             <span>{t.add}</span>
//           </Link>

//           <Link to="/Withdrawopt" className="sa-btn sa-btn-withdraw">
//             <div className="sa-btn-icon-wrapper">
//               <RiBankCard2Fill />
//             </div>
//             <span>{t.withdraw}</span>
//           </Link>
//         </div>

//         {/* History Row */}
//         <Link to="/history" className="sa-history-row">
//           <div className="sa-history-left">
//             <div className="sa-hist-icon-box">
//               <AiOutlineHistory className="sa-hist-icon" />
//             </div>
//             <span className="sa-hist-text">{t.history}</span>
//           </div>
//           <BsArrowRightShort className="sa-arrow" />
//         </Link>

//         {/* Secure Footer Badge */}
//         <div className="sa-secure-footer">
//           <BsShieldCheck className="sa-shield-icon" />
//           <span>{t.encrypted}</span>
//         </div>
//       </div>

//       <div className="rightContainer mobile-hide">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Mywallet;



import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AiOutlinePlus, AiOutlineHistory } from "react-icons/ai";
import { MdVerifiedUser } from "react-icons/md";
import { RiWallet3Fill, RiBankCard2Fill } from "react-icons/ri";
import { BsArrowRightShort, BsShieldCheck } from "react-icons/bs";
import { LanguageContext } from "../Components/LanguageContext";
import Rightcontainer from "../Components/Rightcontainer";
// import "./Mywallet.css";

const Mywallet = ({ user }) => {
  const { language } = useContext(LanguageContext);

  const translations = {
    hi: {
      wallet: "वॉलेट बैलेंस",
      secure: "MKADDA सुरक्षित कैश",
      available: "कुल उपलब्ध शेष",
      deposit: "डिपॉजिट",
      winnings: "विनिंग्स",
      history: "ट्रांजैक्शन हिस्ट्री",
      add: "कैश जोड़ें",
      withdraw: "पैसे निकालें",
      verified: "वेरिफाइड",
      encrypted: "256-बिट सुरक्षित एन्क्रिप्टेड गेटवे",
    },
    en: {
      wallet: "Wallet Balance",
      secure: "MKADDA Secure Cash",
      available: "AVAILABLE BALANCE",
      deposit: "Deposit",
      winnings: "Winnings",
      history: "Transaction History",
      add: "ADD CASH",
      withdraw: "WITHDRAW MONEY",
      verified: "Verified",
      encrypted: "256-BIT SECURE ENCRYPTED GATEWAY",
    },
  };

  const t = translations[language] || translations.en;

  // Existing wallet calculations — unchanged
  const totalBalance = Number(user?.Wallet_balance || 0);
  const winningsBalance = Number(user?.withdrawAmount || 0);
  const depositBalance = Math.max(
    0,
    totalBalance - winningsBalance
  );

  return (
    <div className="sa-luxury-wallet-wrapper leftContainer mt-5 pt-5">
      {/* Ambient background lighting */}
      <div className="sa-wallet-ambient sa-wallet-glow-one" />
      <div className="sa-wallet-ambient sa-wallet-glow-two" />

      <div className="sa-luxury-layout-grid">
        {/* Main wallet area */}
        <main className="sa-wallet-container">
          {/* Wallet heading */}
          <div className="sa-header">
            <div className="sa-header-text">
              <span className="sa-eyebrow">PREMIUM WALLET</span>
              <h1>{t.wallet}</h1>
              <p>{t.secure}</p>
            </div>

            <div className="sa-wallet-icon-box">
              <RiWallet3Fill />
            </div>
          </div>

          {/* Main balance card */}
          <section className="sa-main-balance-card">
            <div className="sa-card-pattern" />
            <div className="sa-card-glow-bg" />

            <div className="sa-balance-top">
              <span className="sa-balance-label">
                {t.available}
              </span>

              <div className="sa-verified-badge">
                <MdVerifiedUser className="sa-badge-icon" />
                <span>{t.verified}</span>
              </div>
            </div>

            <div className="sa-balance-value">
              <span className="currency-symbol">₹</span>
              <span className="amount-number">
                {totalBalance.toFixed(2)}
              </span>
            </div>

            <div className="sa-balance-bottom">
              <span className="sa-balance-bottom-label">
                {t.secure}
              </span>
              <BsShieldCheck className="sa-balance-shield" />
            </div>
          </section>

          {/* Balance breakdown */}
          <section className="sa-breakdown-grid">
            <div className="sa-breakdown-card">
              <div className="sa-breakdown-top">
                <span className="sa-breakdown-dot sa-deposit-dot" />
                <span>{t.deposit}</span>
              </div>

              <div className="sa-breakdown-amount">
                <span>₹</span>
                {depositBalance.toFixed(2)}
              </div>
            </div>

            <div className="sa-breakdown-card">
              <div className="sa-breakdown-top">
                <span className="sa-breakdown-dot sa-winning-dot" />
                <span>{t.winnings}</span>
              </div>

              <div className="sa-breakdown-amount">
                <span>₹</span>
                {winningsBalance.toFixed(2)}
              </div>
            </div>
          </section>

          {/* Wallet actions — routes unchanged */}
          <section className="sa-wallet-actions">
            <Link to="/addcase" className="sa-btn sa-btn-add">
              <div className="sa-btn-icon-wrapper">
                <AiOutlinePlus />
              </div>

              <div className="sa-btn-content">
                <span className="sa-btn-title">{t.add}</span>
                <span className="sa-btn-subtitle">
                  {t.deposit}
                </span>
              </div>

              <BsArrowRightShort className="sa-btn-arrow" />
            </Link>

            <Link
              to="/Withdrawopt"
              className="sa-btn sa-btn-withdraw"
            >
              <div className="sa-btn-icon-wrapper">
                <RiBankCard2Fill />
              </div>

              <div className="sa-btn-content">
                <span className="sa-btn-title">
                  {t.withdraw}
                </span>
                <span className="sa-btn-subtitle">
                  {t.winnings}
                </span>
              </div>

              <BsArrowRightShort className="sa-btn-arrow" />
            </Link>
          </section>

          {/* Transaction history — route unchanged */}
          <Link to="/history" className="sa-history-row">
            <div className="sa-history-left">
              <div className="sa-hist-icon-box">
                <AiOutlineHistory className="sa-hist-icon" />
              </div>

              <div className="sa-history-copy">
                <span className="sa-hist-text">
                  {t.history}
                </span>
                <span className="sa-history-subtitle">
                  {language === "hi"
                    ? "अपने सभी लेन-देन देखें"
                    : "View all your transactions"}
                </span>
              </div>
            </div>

            <div className="sa-history-arrow-box">
              <BsArrowRightShort className="sa-arrow" />
            </div>
          </Link>

          {/* Security footer */}
          <div className="sa-secure-footer">
            <div className="sa-secure-icon">
              <BsShieldCheck className="sa-shield-icon" />
            </div>

            <div className="sa-secure-copy">
              <span className="sa-secure-title">
                {t.verified}
              </span>
              <span className="sa-secure-description">
                {t.encrypted}
              </span>
            </div>

            <MdVerifiedUser className="sa-secure-verified" />
          </div>
        </main>

        {/* Desktop sidebar */}
        <div className="rightContainer mobile-hide">
          <Rightcontainer />
        </div>
      </div>
    </div>
  );
};

export default Mywallet;
